import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

/**
 * Fetch a paginated page of “manufacture inspection” requests.
 * Accepts (page, pageSize) and returns a promise that resolves to:
 * {
 *   data: [ /* array of rows for this page *\/ ],
 *   total: 123,    // total number of matching rows in the database
 *   page: 1,       // current page
 *   page_size: 10  // page size
 * }
 */
export function getInspectionManufactureData({ page = 1, pageSize = 10, search = "", status = "", date_from = "", date_to = "" }) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.get(INSPECTION_URL + "getinspection_requests_manufpanel_pagination", {
        params: {
          page,
          per_page: pageSize,
          search,
          status,
          date_from: date_from,
          date_to: date_to,
        },
      })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

  export function getRemainingInspectionData() {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.get(INSPECTION_URL + 'getremaininginspections' )
          .then((res) => {
            console.warn('InspectorData', res.data)
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
  }